import { Component, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { NumberListViewComponent, TextListViewComponent } from './list-view.component';
import { InputContainerComponent } from '../input-container/input-container.component';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, InputContainerComponent],
    selector: 'wd-list-input',
    templateUrl: 'list-input.component.html',
    styleUrls: ['../styles/view.component.css', '../styles/input.component.css'],
})
export class TextListInputComponent extends TextListViewComponent {
	@ViewChild('inputValue') inputValue!: NgModel;

	constructor() {
		super();
	}

	needsEmptyOption(): boolean {
		// Leereintrag nur anzeigen wenn Liste nicht bereits mit leerem Wert beginnt
		return this.data.length === 0 || !this.isEmptyValue(this.data[0]);
	}

	needsInvalidOption(): boolean {
		return !this.isEmptyValue(this.model) && this.data.findIndex((value: string) => value == this.model) == -1;
	}

	isSelected(value: string) {
		return value === this.model;
	}
}

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, InputContainerComponent],
    selector: 'wd-number-list-input',
    templateUrl: 'list-input.component.html',
    styleUrls: ['../styles/view.component.css', '../styles/input.component.css'],
})
export class NumberListInputComponent extends NumberListViewComponent {
	@ViewChild('inputValue') inputValue!: NgModel;

	constructor() {
		super();
	}

	needsEmptyOption(): boolean {
		// Leereintrag nur anzeigen wenn Liste nicht bereits mit leerem Wert beginnt
		return this.data.length === 0 || !this.isEmptyValue(this.data[0]);
	}

	needsInvalidOption(): boolean {
		// Invalid option nur zeigen wenn Wert vorhanden und nicht in der Liste
		if (this.isEmptyValue(this.model)) return false;
		return this.data.findIndex((value: number) => value == this.model) == -1;
	}

	isSelected(value: number) {
		return value === this.model;
	}

	override onChange(changes?: SimpleChanges) {
		this.model = (typeof(this.model) === 'string') ? this.fromString(this.model) : this.model;
		if (!changes && this.initialized) {
			// User-initiated change (from template ngModelChange)
			this.vs.dirty.next(true);
		}
		if (!this.initialized || this.validate() || this.successOnDanger()) this.modelChange.emit(this.model);
	}

	override helpText(): string {
		if (this.inputValue === undefined || this.inputValue.touched) return super.helpText();
		return '';
	}
}
